import { useState, useEffect, useCallback } from 'react';
import axiosInstance from '../../../axiosInstance';

/**
 * useSubformCommentStatus Hook
 *
 * Fetches all subform-level comments for a request and builds a status map
 * for SubformNavigation indicators: { [subFormId]: true }
 *
 * @param {number|string} requestId - The request ID
 * @returns {{ subformCommentStatus: Object, refreshSubformCommentStatus: Function }}
 */
const useSubformCommentStatus = (requestId) => {
  const [subformCommentStatus, setSubformCommentStatus] = useState({});

  const fetchStatus = useCallback(async () => {
    if (!requestId) return;
    try {
      const response = await axiosInstance.get(
        `/api/subform-comments/request/${requestId}`
      );
      const status = {};
      (response.data || []).forEach((sc) => {
        const subFormId = sc.subForm_id;
        if (subFormId) {
          status[subFormId] = true;
        }
      });
      setSubformCommentStatus(status);
    } catch {
      // Silently fail - no indicator is better than a broken page
    }
  }, [requestId]);

  useEffect(() => {
    fetchStatus();
  }, [fetchStatus]);

  return { subformCommentStatus, refreshSubformCommentStatus: fetchStatus };
};

export default useSubformCommentStatus;
